import React, { useEffect, useState } from 'react'
import ActionButton from '../components/ActionButton';
import { getOrdinal } from '../helper/getOrdinal';
import { useTranslate } from '../components/TranslationText';
import axios from '../axios/axios';
import axiosUmbraco from '../axios/axiosUmbraco';

import Loader from '../components/Loader';
import ComingSoon from '../components/ComingSoon';
import { noDataCard, whiteCard } from '../common/cssclasses';
import { getFileName } from '../helper/getFileName';

const BaseURL = process.env.REACT_APP_BASE_URL;
const pageID = process.env.REACT_APP_UMBRACO_EAHS_AWARD_PAGE_ID;
const umbracoBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;
const isTestApp = process.env.REACT_APP_IS_TEST;

export default function AwardPage() {
    const [activeTab, setActiveTab] = useState(1);
    const [mainActiveTab, setMainActiveTab] = useState(1);
    const [prizeTab, setprizeTab] = useState(1);
    const { translate } = useTranslate();
    const [pointsDestributionData, setPointsDitrebutionData] = useState([]);
    const [liveRanking, setLiveRanking] = useState([]);
    const [umbracoData, setUmbracoData] = useState(null);
    const { loaded, setLoaded } = useState(false);
    const [seniorStallions, setSeniorStallions] = useState([]);
    const [juniorFillies, setJuniorFillies] = useState([]);
    const [seniorMares, setSeniorMares] = useState([]);
    const [juniorColts, setJuniorColts] = useState([]);

    const [availableSeasons, setAvailableSeasons] = useState([]);
    const [selectedSeason, setSelectedSeason] = useState(0);
    const [startYear, setStartYear] = useState('');
    const [endYear, setEndYear] = useState('');
    const [liveRankingLoading, setLiveRankingLoading] = useState(false);

    async function getLatestSeason() {
        const response = await axios.get('eahsaward/getseasonslist');
        const avlSeasons = response.data.result || [];

        setAvailableSeasons(avlSeasons);

        if (avlSeasons.length > 0) {
            const lastIndex = avlSeasons.length - 1;
            setSelectedSeason(lastIndex);
            const [startDate, endDate] = avlSeasons[lastIndex].split("-");
            setStartYear(startDate?.trim());
            setEndYear(endDate?.trim());
        }
    }

    useEffect(() => {
        if (availableSeasons.length > 0) {
            const [startDate, endDate] = availableSeasons[selectedSeason]?.split("-") || [];
            setStartYear(startDate?.trim() || '');
            setEndYear(endDate?.trim() || '');
            getLiveRankingData(startDate?.trim(), endDate?.trim() || '');
        }
    }, [selectedSeason, availableSeasons]);

    function handleNext() {
        if (selectedSeason < availableSeasons.length - 1) {
            setSelectedSeason(prev => prev + 1);
        }
    }

    function handlePrev() {
        if (selectedSeason > 0) {
            setSelectedSeason(prev => prev - 1);
        }
    }



    async function getPointsDestributionData() {
        try {
            const response = await axios.get('eahsaward/geteahsawardmatrix');
            if (response.data.responseCode == "200") {

                const res = response.data.result;
                // console.debug('res is' , res);
                const fres = formatData(res);
                setPointsDitrebutionData(fres);
            }
        } catch (error) {
            console.error('error in getting pointsDestributionData', error);
        }

    }

    async function getLiveRankingData(startDate, endDate) {
        try {
            let url = `eahsaward/geteahsawardrankingwithyearfilter?startYear=${startDate}&endYear=${endDate}`

            setLiveRankingLoading(true);
            const response = await axios.get(url);
            if (response.data.responseCode == "200") {
                setLiveRanking(response.data.result);
                if (response.data.result?.length > 0) {
                    const catArray = [...Array.from(new Set(response.data.result?.sort((b, a) => b?.categoryOrder - a?.categoryOrder).map(horse => horse?.category)))]
                    if (catArray.length > 0) {
                        setActiveTab(catArray[0]);
                    }
                }
            }
            setLiveRankingLoading(false);
        } catch (error) {
            console.error('error in getting LiveRanking Data', error);
            setLiveRankingLoading(false);
        }
    }

    async function getDataFromUmbraco() {

        try {
            const res = await axiosUmbraco.get(`umbraco/delivery/api/v1/content/item?id=${pageID}`);
            if (res.data.length > 0) {
                setUmbracoData(res?.data[0]?.properties);
                setLoaded(true);
            }
        } catch (error) {
            console.error('error in Loading Data From Umbraco', error);
        }

    }

    const getPrizesData = async () => {
        try {
            const response = await axiosUmbraco.get(`umbraco/delivery/api/v1/content?fetch=children:${pageID}&skip=0&take=10000`); // Replace with your API endpoint
            const items = response.data.items;

            // Process items into respective categories
            const seniorStallions = items.filter(item => item.properties.prizeCategory === 'Senior Stallions')
                .sort((a, b) => a.properties.rank - b.properties.rank);
            const juniorFillies = items.filter(item => item.properties.prizeCategory === 'Junior Fillies')
                .sort((a, b) => a.properties.rank - b.properties.rank);
            const seniorMares = items.filter(item => item.properties.prizeCategory === 'Senior Mares')
                .sort((a, b) => a.properties.rank - b.properties.rank);
            const juniorColts = items.filter(item => item.properties.prizeCategory === 'Junior Colts')
                .sort((a, b) => a.properties.rank - b.properties.rank);

            // Set the state for each category
            setSeniorStallions(seniorStallions);
            setJuniorFillies(juniorFillies);
            setSeniorMares(seniorMares);
            setJuniorColts(juniorColts);
        } catch (error) {
            console.error("Error fetching data: ", error);
        }
    };

    const lang = localStorage.getItem('eahsLang') ?? 'en';

    useEffect(() => {
        getLatestSeason();
        getPointsDestributionData();
        getLiveRankingData();
        getDataFromUmbraco();
        getPrizesData();
    }, [])

    const buildRankKeyMap = (responseData) => {
        const keyMap = {};

        responseData.flat().forEach(item => {
            const rawName = item?.showRankName?.trim();
            if (!(rawName in keyMap)) {
                // Optional: Normalize the key (e.g., remove dots, lowercase, trim)
                const normalizedKey = rawName.toLowerCase();
                keyMap[rawName] = normalizedKey;
            }
        });

        return keyMap;
    };


    const formatData = (responseData) => {
        const rankKeyMap = buildRankKeyMap(responseData);

        return responseData.map((rankArray) => {
            const reformattedObject = {};

            if (rankArray.length > 0) {
                reformattedObject.classRank = rankArray[0].classRank;
            }

            rankArray.forEach((item) => {
                const key = rankKeyMap[item.showRankName];
                if (key) {
                    reformattedObject[key] = item.points;
                }
            });

            return reformattedObject;
        });
    };


    function filterClassDataByCategory(activeTab) {
        let data;
        data = liveRanking.filter(x => x.category == activeTab)
        return data;
    }

    const getSortedKeysByMax = (data) => {
        const maxMap = {};

        data.forEach(row => {
            Object.entries(row).forEach(([key, value]) => {
                if (key !== 'classRank') {
                    maxMap[key] = Math.max(maxMap[key] || 0, value || 0);
                }
            });
        });

        return Object.entries(maxMap)
            .sort((a, b) => b[1] - a[1])
            .map(([key]) => key);
    };
    const sortedKeysByMax = getSortedKeysByMax(pointsDestributionData);


    const uniqueCategories = [...Array.from(new Set(liveRanking?.sort((b, a) => b?.categoryOrder - a?.categoryOrder).map(horse => horse?.category)))];


    return (
        <>
            {loaded ? <Loader /> :
                <>
                    {(umbracoData == null || (umbracoData?.Published == false)) ? <ComingSoon /> :
                        <div className='row rtl'>
                            <div className='col-12'>
                                <div className={whiteCard}>
                                    {umbracoData.headerImage.length > 0 &&
                                        <img src={`${umbracoBaseURL}${umbracoData.headerImage[0]?.url}`} alt={getFileName(umbracoData.headerImage[0]?.url)} className='w-100 border-15' />
                                    }
                                    <div className="mainSpacer my-4" />
                                    <h2 className='bold rtl capatalise'>{umbracoData?.title}</h2>
                                    <div className='row mb-main rtl'>
                                        <div className='col-12' >
                                            {umbracoData?.subtitle}
                                        </div>
                                    </div>

                                    <div className='row second_section_bar mx-0'>
                                        <div
                                            className={'col-3 my-2 text-center px-0'}
                                            style={{ cursor: 'pointer', minWidth: 250 }}
                                            id="second_most_used_services"
                                            onClick={() => {
                                                setMainActiveTab(0);
                                                setTimeout(() => {
                                                    setMainActiveTab(1);
                                                }, 200);
                                            }}
                                        >
                                            <span className={`${mainActiveTab == 1 ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{lang == 'en' ? 'Award’s rules' : 'قوانين الجائزة'}</span>
                                            <div className="service_bar_underline" style={mainActiveTab == 1 ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                                        </div>
                                        <div
                                            className={'col-3 my-2 text-center px-0'}
                                            style={{ cursor: 'pointer', minWidth: 250 }}
                                            id="second_most_used_services"
                                            onClick={() => {
                                                setMainActiveTab(0);
                                                setTimeout(() => {
                                                    setMainActiveTab(2);
                                                }, 200);
                                            }}
                                        >
                                            <span className={`${mainActiveTab == 2 ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{lang == 'en' ? 'Points distribution table' : 'جدول توزيع النقاط'}</span>
                                            <div className="service_bar_underline" style={mainActiveTab == 2 ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                                        </div>
                                        <div
                                            className={'col-3 my-2 text-center px-0'}
                                            style={{ cursor: 'pointer', minWidth: 250 }}
                                            onClick={() => {
                                                setMainActiveTab(0);
                                                setTimeout(() => {
                                                    setMainActiveTab(3);
                                                }, 200);
                                            }}
                                        >
                                            <span className={`${mainActiveTab == 3 ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{lang == 'en' ?
                                                'Prize money' : 'الجوائز المالية'
                                            }</span>
                                            <div className="service_bar_underline" style={mainActiveTab == 3 ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                                        </div>
                                        <div
                                            className={'col-3 my-2 text-center px-0'}
                                            style={{ cursor: 'pointer', minWidth: 250 }}
                                            id="second_most_used_services"
                                            onClick={() => {
                                                setMainActiveTab(0);
                                                setTimeout(() => {
                                                    setMainActiveTab(4);
                                                }, 200);
                                            }}
                                        >
                                            <span className={`${mainActiveTab == 4 ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>
                                                {lang == 'en' ?
                                                    'Live ranking' : 'النتائج اللحظية'
                                                }</span>
                                            <div className="service_bar_underline" style={mainActiveTab == 4 ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                                        </div>
                                    </div>
                                    {mainActiveTab == 1 &&
                                        <div dangerouslySetInnerHTML={{ __html: umbracoData?.awardRules?.markup }} />
                                    }
                                    {mainActiveTab == 2 &&
                                        <>
                                            <h5 className='bold mt-4 text-center'>
                                                {lang == 'en' ? 'Points distribution table' : 'جدول توزيع النقاط'}
                                            </h5>
                                            <div className="scrolableTable mx-auto " style={{ maxWidth: 800 }}>
                                                <table className="table table-striped table-bordered rtl horseResultTable">
                                                    <thead className="theadHorseSelect">

                                                        <tr>
                                                            <th className="text-center">
                                                                {lang == 'en' ? 'Rank' : 'المركز'}
                                                            </th>
                                                            {
                                                                // Dynamically render headers from keys, assuming at least one row exists
                                                                sortedKeysByMax
                                                                    .map((key) => (
                                                                        <th key={key} className="rtl text-center text-capitalize">
                                                                            {key}
                                                                        </th>
                                                                    ))
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody className="text-center">
                                                        {pointsDestributionData.map((x, index) => (
                                                            <tr >
                                                                <td className="rtl text-center bold">{x.classRank}</td>
                                                                {
                                                                    sortedKeysByMax
                                                                        .map((key) => (
                                                                            <td key={key} className="rtl text-center">
                                                                                {x[key]}
                                                                            </td>
                                                                        ))
                                                                }
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                {lang == 'en' ? '' : <p style={{ fontSize: '12px' }} class="bold text-start text-danger">* اللغة المعتمدة هي اللغة الانجليزية</p>}
                                            </div>
                                        </>
                                    }
                                    {mainActiveTab == 3 &&
                                        <div className='col-12  mt-3'>

                                            <h5 className='bold'> {umbracoData?.prizeTitle}</h5>
                                            <h5 className='bold mt-3'>{umbracoData?.prizeSubtitle}</h5>
                                            <div dangerouslySetInnerHTML={{ __html: umbracoData?.currentSeason?.markup }} />
                                            {/* <ul>
                                                <li>
                                                    {lang == 'en' ? 'Junior Fillies' : 'المهرات'}
                                                </li>
                                                <li>
                                                    {lang == 'en' ? 'Senior Mares' : 'الأفراس'}
                                                </li>
                                                <li>
                                                    {lang == 'en' ?
                                                        'Junior Colts' : 'الأمهار'
                                                    }
                                                </li>
                                                <li>
                                                    {lang == 'en' ?
                                                        'Senior Stallions' : 'الفحول'
                                                    }
                                                </li>

                                            </ul> */}
                                            <h5 className='bold my-3'>{umbracoData?.totalPrizeMoneyLable}</h5>
                                            {(prizeTab == 1 || prizeTab == 2 || prizeTab == 3 || prizeTab == 4) &&
                                                <div className='row rtl mt-3   '>
                                                    <div className='col-lg-6 col-md-6 col-sm-12'>
                                                        <table className="table tablenominwidth table-striped table-bordered rtl horseResultTable">
                                                            <thead className="theadHorseSelect">

                                                                <tr>
                                                                    <th className="text-center">
                                                                        {translate('web.rank', 'Rank')}
                                                                    </th>
                                                                    <th className="text-center">
                                                                        {translate('web.prizeVal', 'Prize Value')}
                                                                    </th>

                                                                </tr>
                                                            </thead>
                                                            <tbody className="text-center">
                                                                {prizeTab == 1 && juniorFillies.map((x, index) => (
                                                                    <tr >
                                                                        <td className="rtl text-center bold" dangerouslySetInnerHTML={{ __html: getOrdinal(x.properties.rank, lang) }} />
                                                                        <td
                                                                            className={`rtl text-center `}
                                                                        >
                                                                            {x.properties.prizeValue.toLocaleString('en-US')}  {translate('web.aed', 'AED')}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    }
                                    {mainActiveTab == 4 &&
                                        <>
                                            <div className="calnderuttonsContainer mt-3">
                                                <div className="calenderBtn rounded" title={translate('web.prev', 'Prev')} style={{ opacity: (selectedSeason > 0) ? 1 : 0.5 }} onClick={handlePrev}>
                                                    <i className=" fa-solid fa-chevron-left justRotate w-unset"></i>
                                                </div>
                                                <div className="year fc-toolbar-title  rtl">
                                                    {translate('web.seasonResult', 'Season Result')} {startYear} - {endYear}
                                                </div>
                                                <div className="calenderBtn rounded" title={translate('web.next', 'Next')} style={{ opacity: (selectedSeason < availableSeasons.length - 1) ? 1 : 0.5 }} onClick={handleNext}>
                                                    <i className=" fa-solid fa-chevron-right justRotate w-unset"></i>
                                                </div>
                                            </div>
                                            {liveRankingLoading ? <Loader /> :
                                                <>
                                                    <div className=' second_section_bar  mx-0' style={{ flexWrap: 'nowrap', overflowX: 'auto' }}>
                                                        {uniqueCategories?.map((category) => (
                                                            <div
                                                                className={'col-3 w-unset my-2 text-center px-0'}
                                                                style={{ cursor: 'pointer', minWidth: 250 }}
                                                                id="second_most_used_services"
                                                                onClick={() => {
                                                                    setActiveTab(0);
                                                                    setTimeout(() => {
                                                                        setActiveTab(category);
                                                                    }, 200);
                                                                }}
                                                            >
                                                                <span className={`${activeTab == category ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>{translate(`web.${category}`, category)}</span>
                                                                <div className="service_bar_underline" style={activeTab == category ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className='col-12  mt-2 currentFont'>
                                                        {liveRanking.length > 0 ?
                                                            <div className="scrolableTable px-2">
                                                                <table className="table table-striped table-bordered rtl horseResultTable mb-0">
                                                                    <thead className="theadHorseSelect">
                                                                        <tr>
                                                                            <th className="text-center">
                                                                                {translate('web.rank', 'Rank')}
                                                                            </th>
                                                                            <th className="text-center">
                                                                                {translate('web.ownerRegNo', 'Owner Reg No')}
                                                                            </th>
                                                                            <th className="text-center">
                                                                                {translate('web.owner', 'Owner')}
                                                                            </th>
                                                                            <th className="text-center">
                                                                                {translate('web.horseRegNo', 'Horse Reg No')}
                                                                            </th>
                                                                            <th className="text-center">
                                                                                {translate('web.theHorse', 'Horse')}
                                                                            </th>
                                                                            <th className="text-center">
                                                                                {translate('web.totalPoints', 'Total Points')}
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="text-center">
                                                                        {filterClassDataByCategory(activeTab).map((x, index) => (
                                                                            <tr >
                                                                                <td className="rtl text-center bold" dangerouslySetInnerHTML={{ __html: getOrdinal(x.finalRank, lang) }} />
                                                                                <td className="rtl text-center">
                                                                                    {x.ownerRegNo}
                                                                                </td>
                                                                                <td className="rtl text-center">
                                                                                    {x.owner}
                                                                                </td>
                                                                                <td className="rtl text-center">
                                                                                    {x.horseRegNo}
                                                                                </td>
                                                                                <td className="rtl text-center">
                                                                                    {x.horse}
                                                                                </td>
                                                                                <td className={`rtl text-center`}>
                                                                                    {x.totalPoints}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                                {/* {(selectedSeason == availableSeasons.length - 1) &&
                                                                    <h4 class="alert rounded alert-danger mt-2 mx-auto mb-0 " style={{ fontSize: 21 }} role="alert">
                                                                        {translate('web.resultsAreIndicative', 'The results are indicative and temporary, and not final.')}
                                                                    </h4>
                                                                } */}
                                                            </div> :
                                                            <div className={noDataCard}>
                                                                {translate("web.nodataFound", "No Result Found")}
                                                            </div>

                                                        }
                                                    </div>
                                                </>
                                            }


                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </>
            }
        </>
    )
}
